<template>

    <div class="mt-6 mb-0 inline-flex w-full flex-col items-start justify-start">

      <p class="mb-1 text-sm text-neutral-900">{{ checkout.numberTotalTickets }} {{ checkout.numberTotalTickets > 1 ? $t('common.tickets') : $t('common.ticket') }}:</p>

      <!-- TICKETS -->
      <SummaryItem v-for="[key, item] in checkout.getSummaryItems()" :key="key" :item="item"/>

      <hr class="mb-3 mt-[5px] w-full border-neutral-200">

      <!-- OPERATION COSTS -->
      <template v-if="total_fees > 0">
        <div class="flex w-full items-center justify-between text-sm text-neutral-900">
          <div class="inline-flex items-center justify-start gap-3 pr-3">
            <p class="cursor-pointer text-sm underline md:text-base" @click="handleClick">{{ $t('common.operation_costs.title') }}</p>
          </div>
          <div class="text-sm md:text-base">
            {{ money(total_fees) }}
          </div>
        </div>

        <hr class="my-3 w-full border-neutral-200">
      </template>

      <template v-if="insurance_fees">
        <div class="flex w-full items-center justify-between text-sm text-neutral-900">
          <div class="inline-flex items-center justify-start gap-3 pr-3">
            <p class="text-sm md:text-base">{{ $t('common.insurance.title') }}</p>
          </div>
          <div class="text-sm md:text-base">
            {{ money(insurance_fees) }}
          </div>
        </div>

        <hr class="my-3 w-full border-neutral-200">
      </template>

      <template v-if="checkout.coupon">
        <div class="flex w-full items-center justify-between text-sm text-neutral-900">
          <div class="inline-flex items-center justify-start gap-3 pr-3">
            <p class="text-sm md:text-base">{{ $t('common.coupon') }} "{{ checkout.coupon.code }}" {{ $t('common.applied') }}</p>
          </div>
        </div>

        <hr class="my-3 w-full border-neutral-200">
      </template>

      <!-- TOTAL -->
      <div class="flex w-full justify-between text-base font-medium text-neutral-900">
        <span>{{ $t('common.total') }}</span>
        <span>{{ money(checkout.total) }}</span>
      </div>

    </div>

</template>

<script lang="ts" setup>
import {useCheckoutStore} from "~/store/checkout"
import {useMoneyFormatter} from "~/composables/moneyFormatter";

const emit = defineEmits(['operation'])

defineProps({
  title: String,
})

const money = useMoneyFormatter()
const checkout = useCheckoutStore()
const event = checkout.$state.event
const tickets = checkout.$state.line_items
const dayjs = useDayjs()

const modelValue = useAttrs().modelValue as ModalModel
modelValue.title="modal.order_summary.title"
modelValue.icon="pricing"

const total_fees = computed(() => checkout.pi?.participant_fee.amount )
const insurance_fees = computed(() => checkout.insurance?.amounts?.amount )

function handleClick() {
  emit('operation')
}
</script>
